import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      paymentSummary: 'Payment Summary',
      processing: {
        Payment: 'Processing payment transaction..',
        Setup: 'Processing payment method capture..',
        tokenization: 'Processing your card information..',
      },
      amount: 'Amount',
      total: 'Total',
      verifying: 'Verifying the link..',
      Tax: 'Tax',
      tokenBtn: {
        Payment: 'Pay Now',
        Setup: 'Submit',
      },
      confirmTitle: {
        Payment: 'Confirm Payment',
        Setup: 'Confirm information capture',
      },
      confirmQuestion: {
        Payment: 'Are you sure you want to proceed with the payment?\nAmount: {{amount}}',
        Setup: 'Are you sure you want to proceed with the capturing of the provided information?',
      },
      confirm: 'Confirm',
      PayNow: 'Pay Now',
      cancel: 'Cancel',
      retry: 'Retry',
      status: {
        success: 'Processed successfully',
        failed: 'Something went wrong',
        cancelled: 'Cancelled successfully',
        cancelledMessage: 'Processing has been cancelled, you can try again from the beginning.',
      },
      error: {
        unexpected: 'An unexpected error occurred. Please try again later.',
        tokenization:
          'There was an issue capturing your payment method information. Please verify your information and try again.',
        40001: 'Invalid request. Please check your input and try again.',
        40010: 'Invalid request. Please try again later.',
        40032: 'Could not find your request. Please try again later.',
        50000: 'Something went wrong on our side. Please try again later.',
        50001: 'Something went wrong on our side. Please try again later.',
        50002: 'This link is invalid. Please check your link and try again.',
        50003: 'This request is no longer available.',
        50004: 'This request is no longer available.',
        50005: 'There is something wrong with your request. Please check your link and try again.',
        50006: 'Something went wrong on our side. Please try again later.',
        50007: 'Your request is already being processed.',
        50008: 'Your request is already being processed.',
        50015: 'This request is no longer available.',
        50009: 'Something went wrong on our side. Please try again later.',
        50010: 'There was an issue processing your payment.',
        50011: 'There was an issue processing your payment.',
        50012:
          'There was an issue processing your payment method information. Please verify your information and try again.',
        50013:
          'There was an issue processing your payment method information. Please verify your information and try again.',
        50014:
          'There are issues with payment method capturing on our side, no payment method options are available. Please try again later.',
        50016: 'There was a problem with capturing your signature. Please try again.',
        plaid: 'There was an issue connecting your bank account. Please try again.',
        plaidLoad: 'There was an issue initializing bank account capture. Please try again later.',
      },
      paymentMethodSelect: {
        title: 'What payment method would you like to use?',
        tokenizedCard: 'Use Credit Card',
        bankAccountDebit: 'Use Bank Account',
      },
      bankAccountForm: {
        title: 'Connect your bank account with Plaid',
        button: 'Connect with Plaid',
        benefits: {
          fast: {
            title: 'Fast and simple',
            text: 'Log in to your financial institution and set up in 3 easy steps',
          },
          accurate: {
            title: 'More accurate',
            text: 'Feel assured that your banking details are correct and your payments will go through',
          },
          secure: {
            title: 'Trusted and secure',
            text: 'Your data is tokenized and protected by high level 256-bit SSL encryption',
          },
        },
      },
      signature: {
        message: 'Please sign below with your name',
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        firstNameValError: 'First name must be between 2 and 50 characters long',
        lastNameValError: 'Last name must be between 2 and 50 characters long',
      },
      reasons: {
        title: "We've got you covered",
        security: 'Secure transactions',
        savings: 'Bundle and save',
        ease: 'Easy online management',
      },
      'Your payment has been processed successfully.': 'Your payment has been processed successfully.',
      'There was an issue processing your payment. Please try again.':
        'There was an issue processing your payment. Please try again.',
      'No payment information found.': 'No payment information found.',
      Disclaimer: {
        TELUS:
          'The information displayed on this page will be kept encrypted and secure. By pressing Pay Now, I consent to TELUS submitting this data to my credit card provider for validation and billing purposes.',
        KOODO:
          'The information displayed on this page will be kept encrypted and secure. By pressing Pay Now, I consent to KOODO submitting this data to my credit card provider for validation and billing purposes.',
        PUBLIC_MOBILE:
          'The information displayed on this page will be kept encrypted and secure. By pressing Pay Now, I consent to PUBLIC MOBILE submitting this data to my credit card provider for validation and billing purposes.',
      },
      InvalidLink: 'The link you have followed is invalid. Please try again with a new link.',
      'Payment Portal': 'Payment Portal',
      copyright: '© {{year}} {{brand}}',
      testModeBanner:
        'This link is in the simulation mode - no requests will be sent to Global Payments, card networks or banks.',
    },
  },
  fr: {
    translation: {
      paymentSummary: 'Résumé du paiement',
      processing: {
        Payment: 'Traitement de la transaction de paiement..',
        Setup: 'Traitement de la capture du mode de paiement..',
        tokenization: 'Traitement des informations de votre carte..',
      },
      amount: 'Montant',
      total: 'Total',
      verifying: 'Vérification du lien..',
      Tax: 'Taxe',
      tokenBtn: {
        Payment: 'Payer maintenant',
        Setup: 'Soumettre',
      },
      confirmTitle: {
        Payment: 'Confirmer le paiement',
        Setup: "Confirmer la capture d'information",
      },
      confirmQuestion: {
        Payment: 'Êtes-vous sûr de vouloir continuer avec le paiement?\nMontant: {{amount}}',
        Setup: 'Êtes-vous sûr de vouloir continuer avec la capture des informations fournies?',
      },
      confirm: 'Confirmer',
      PayNow: 'Payer maintenant',
      cancel: 'Annuler',
      retry: 'Réessayer',
      status: {
        success: 'Traité avec succès',
        failed: 'Quelque chose s’est mal passé',
        cancelled: 'Annulé avec succès',
        cancelledMessage: 'Le traitement a été annulé, vous pouvez réessayer depuis le début.',
      },
      error: {
        unexpected: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
        tokenization:
          'Il y a eu un problème lors de la capture des informations de votre mode de paiement. Veuillez vérifier vos informations et réessayer.',
        40001: 'Requête invalide. Veuillez vérifier vos informations et réessayer.',
        40010: 'Requête invalide. Veuillez réessayer plus tard.',
        40032: 'Impossible de trouver votre demande. Veuillez réessayer plus tard.',
        50000: 'Un problème est survenu de notre côté. Veuillez réessayer plus tard.',
        50001: 'Un problème est survenu de notre côté. Veuillez réessayer plus tard.',
        50002: 'Ce lien est invalide. Veuillez vérifier votre lien et réessayer.',
        50003: "Cette demande n'est plus disponible.",
        50004: "Cette demande n'est plus disponible.",
        50005: 'Il y a un problème avec votre demande. Veuillez vérifier votre lien et réessayer.',
        50006: 'Un problème est survenu de notre côté. Veuillez réessayer plus tard.',
        50007: 'Votre demande est déjà en cours de traitement.',
        50008: 'Votre demande est déjà en cours de traitement.',
        50015: "Cette demande n'est plus disponible.",
        50009: 'Un problème est survenu de notre côté. Veuillez réessayer plus tard.',
        50010: 'Il y a eu un problème lors du traitement de votre paiement.',
        50011: 'Il y a eu un problème lors du traitement de votre paiement.',
        50012:
          'Il y a eu un problème lors du traitement des informations de votre mode de paiement. Veuillez vérifier vos informations et réessayer.',
        50013:
          'Il y a eu un problème lors du traitement des informations de votre mode de paiement. Veuillez vérifier vos informations et réessayer.',
        50014:
          "Il y a des problèmes avec la capture du mode de paiement de notre côté, aucune option de mode de paiement n'est disponible. Veuillez réessayer plus tard.",
        50016: 'Il y a eu un problème lors de la capture de votre signature. Veuillez réessayer.',
        plaid: 'Il y a eu un problème lors de la connexion de votre compte bancaire. Veuillez réessayer.',
        plaidLoad:
          "Il y a eu un problème lors de l'initialisation de la capture du compte bancaire. Veuillez réessayer plus tard.",
      },
      paymentMethodSelect: {
        title: 'Quel mode de paiement souhaitez-vous utiliser?',
        tokenizedCard: 'Utiliser une carte de crédit',
        bankAccountDebit: 'Utiliser un compte bancaire',
      },
      bankAccountForm: {
        title: 'Connectez votre compte bancaire avec Plaid',
        button: 'Connecter avec Plaid',
        benefits: {
          fast: {
            title: 'Rapide et simple',
            text: 'Connectez-vous à votre institution financière et configurez-vous en 3 étapes faciles',
          },
          accurate: {
            title: 'Plus précis',
            text: 'Soyez assuré que vos coordonnées bancaires sont correctes et que vos paiements seront effectués',
          },
          secure: {
            title: 'Fiable et sécurisé',
            text: 'Vos données sont tokenisées et protégées par un cryptage SSL de haut niveau 256 bits',
          },
        },
      },
      signature: {
        message: 'Veuillez signer ci-dessous avec votre nom',
        firstNameLabel: 'Prénom',
        lastNameLabel: 'Nom de famille',
        firstNameValError: 'Le prénom doit comporter entre 2 et 50 caractères',
        lastNameValError: 'Le nom de famille doit comporter entre 2 et 50 caractères',
      },
      reasons: {
        title: "On s'occupe de tout",
        security: 'Transactions sécurisées',
        savings: 'Groupez et économisez',
        ease: 'Gestion en ligne facile',
      },
      'Your payment has been processed successfully.': 'Votre paiement a été traité avec succès.',
      'There was an issue processing your payment. Please try again.':
        'Il y a eu un problème lors du traitement de votre paiement. Veuillez réessayer.',
      'No payment information found.': 'Aucune information de paiement trouvée.',
      'The information displayed on this page will be kept encrypted and secure. By pressing Pay now, I consent to TELUS submitting this data to my credit card provider for validation and billing purposes.':
        'Les informations affichées sur cette page seront conservées de manière cryptée et sécurisée. En appuyant sur Payer maintenant, je consens à ce que TELUS soumette ces données à mon fournisseur de carte de crédit à des fins de validation et de facturation.',
      Disclaimer: {
        TELUS:
          'Les informations affichées sur cette page seront conservées de manière cryptée et sécurisée. En appuyant sur Payer maintenant, je consens à ce que TELUS soumette ces données à mon fournisseur de carte de crédit à des fins de validation et de facturation.',
        KOODO:
          'Les informations affichées sur cette page seront conservées de manière cryptée et sécurisée. En appuyant sur Payer maintenant, je consens à ce que KOODO soumette ces données à mon fournisseur de carte de crédit à des fins de validation et de facturation.',
        PUBLIC_MOBILE:
          'Les informations affichées sur cette page seront conservées de manière cryptée et sécurisée. En appuyant sur Payer maintenant, je consens à ce que PUBLIC MOBILE soumette ces données à mon fournisseur de carte de crédit à des fins de validation et de facturation.',
      },
      InvalidLink: 'Le lien que vous avez suivi est invalide. Veuillez réessayer avec un nouveau lien.',
      'Payment Portal': 'Portail de paiement',
      copyright: '© {{year}} {{brand}}',
      testModeBanner:
        'Ce lien est en mode simulation - aucune demande ne sera envoyée à Global Payments, aux réseaux de cartes ou aux banques.',
    },
  },
};

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ['en', 'fr'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
